// extracted by mini-css-extract-plugin
module.exports = {"animate-height":"Tabs_animate-height__2dKcC","Tabs":"Tabs_Tabs__22rzR","TabItem":"Tabs_TabItem__3xB0Z","Active":"Tabs_Active__YgLfo","animateHeight":"Tabs_animateHeight__1W9Fv"};